<section *ngIf="enfermerasPageInformacion" class="card">
    <h2 style="text-align: center;">Enfermeras</h2>
    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="center">
            <form [formGroup]="busquedaForm" (ngSubmit)="onSubmit()" class="busqueda-form">
                    <div class="busqueda-campo">
                        <input id="firstname" pInputText type="text"
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                            placeholder="Nombre" formControlName="nombre" />
                    </div>
                    <div class="busqueda-campo">
                        <input id="lastname1" pInputText type="text"
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                            placeholder="Apellido Paterno" formControlName="apellido_paterno" />
                    </div>
                    <div class="busqueda-campo">
                        <input id="lastname2" pInputText type="text"
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                            placeholder="Apellido Materno" formControlName="apellido_materno" />
                    </div>
               
                    <div class="busqueda-acciones">
                        <p-button icon="pi pi-search" type="submit"
                            styleClass="p-button-rounded p-button-success p-button-text p-button-raised"></p-button>
                    </div>
            </form>
        </ng-template>

    </p-toolbar>
    <p-toolbar styleClass="mb-4 gap-1">
        <ng-template pTemplate="center">
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>
        </ng-template>


    </p-toolbar>
    <p-table [value]="enfermeraPage" [tableStyle]="{ 'min-width': '50rem', 'font-size': '12px' }" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>Enfermera</th>
                <th>No. Casos Clínicos</th>
                <th>No. Médicos</th>
                <th style="text-align: center;">Acciones</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-usuario>
            <tr *ngIf="usuario.enfermera">
                <td>
                    <a [class.linea-texto]="usuario.activo==0"
                        [routerLink]="['/administrador/enfermera', usuario.enfermera.id]">
                        {{usuario.nom_completo | uppercase}}
                    </a>
                </td>
                <td>{{usuario.enfermera.casosclinicos.length}}</td>
                <td>{{usuario.enfermera.medicos.length}}</td>
                <td style="text-align: center;">
                    <!-- 
                        <a [routerLink]="['/administrador/usuario/actualizar', 'enfermera', usuario.enfermera.id]">
                            <i class="pi pi-pencil" style="color: slateblue"></i>
                        </a>
                    -->
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                No. Registros: {{enfermerasPageInformacion.total}}, Total paginas
                {{enfermerasPageInformacion.last_page}}
            </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron enfermeras</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"></p-paginator>
    </div>
</section>